import { render, staticRenderFns } from "./new_School_score.vue?vue&type=template&id=2752ab85&scoped=true&"
import script from "./new_School_score.vue?vue&type=script&lang=js&"
export * from "./new_School_score.vue?vue&type=script&lang=js&"
import style0 from "./new_School_score.vue?vue&type=style&index=0&id=2752ab85&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2752ab85",
  null
  
)

export default component.exports